module.exports = __webpack_public_path__ + "img/payment-illustration.1fd24a91.png";